import { absolutePath } from "./absolutePath";

// Deliberately outside the `paywalls/checkout` namespace -- mirrors the
// backend route, which is domain-namespaced rather than paywalls-specific
// (PAY-404, Slice 1.2).
export const conversionTracking = {
  create: () => absolutePath("conversion_tracking"),
  adminSettings: () => absolutePath("admin/conversion_tracking"),
};
